module.exports = __webpack_public_path__ + "static/media/brycen8.453ea64f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen8.gif
// module id = 153
// module chunks = 0